export interface ISizes {
  container: string

  /**
   * **Extra small screens**
   *
   * width: 22rem / 352px
   */
  xsContainer: string

  /**
   * **Small screens**
   *
   * Width: 36rem / 576px
   */
  smContainer: string

  /**
   * **Medium screens**
   *
   * Width: 48rem / 768px
   */
  mdContainer: string

  /**
   * **Large screens**
   *
   * Width: 62rem / 992px
   */
  lgContainer: string

  /**
   * **Extra large screens**
   *
   * Width: 75rem / 1200px
   */
  xlContainer: string

  /**
   * **Nothing**
   *
   * Width: 0
   */
  zero: '0'
}

export const sizes: ISizes = {
  container: '100%',
  xsContainer: '22rem',
  smContainer: '36rem',
  mdContainer: '48rem',
  lgContainer: '62rem',
  xlContainer: '75rem',
  zero: '0',
}

export const getMinWidth = (size: keyof ISizes): string => `(min-width: ${sizes[size]})`
